import React from "react";
import { MAX_QUANTITY } from "../constants";
import { OnBlurInput } from "./OnBlurInput";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function QuantityInput(props) {
  return (
    <OverlayTrigger
      trigger="focus"
      placement="top"
      overlay={
        <Tooltip id="quantity_tooltip">
          The quantity can be from {props.min || 1} to {props.max || MAX_QUANTITY}
        </Tooltip>
      }
    >
      <OnBlurInput min={1} max={MAX_QUANTITY} {...props} />
    </OverlayTrigger>
  );
}
